import { api } from '@/lib/api'
import type {
  GameListResponse,
  Game,
  GameRewardStatus,
  RewardHistoryResponse,
  ClaimResult,
  ApiResponse,
} from './types'

// 获取已上架游戏列表
export async function getGames(category?: string): Promise<ApiResponse<GameListResponse>> {
  const params: Record<string, string> = { p: '1', page_size: '50' }
  if (category) params.category = category
  const res = await api.get('/api/games/', { params })
  return res.data
}

// 获取游戏详情
export async function getGameDetail(idOrSlug: string): Promise<ApiResponse<Game>> {
  const res = await api.get(`/api/games/play/${idOrSlug}`)
  return res.data
}

// 获取游戏奖励状态
export async function getGameRewardStatus(slug: string): Promise<ApiResponse<GameRewardStatus>> {
  const res = await api.get(`/api/user/game/${slug}/reward-status`)
  return res.data
}

// 领取游戏奖励
export async function claimGameReward(slug: string, score: number): Promise<ApiResponse<ClaimResult>> {
  const res = await api.post(`/api/user/game/${slug}/claim`, { score })
  return res.data
}

// 获取奖励历史
export async function getRewardHistory(page = 1, pageSize = 20): Promise<ApiResponse<RewardHistoryResponse>> {
  const res = await api.get(`/api/user/game/rewards?page=${page}&page_size=${pageSize}`)
  return res.data
}

// 解析游戏播放地址
export function resolvePlayUrl(game: Game): string {
  if (game.play_type === 'external') {
    return game.play_url || ''
  }
  if (game.play_type === 'html') {
    return game.play_url || `/game-files/${game.slug}.html`
  }
  return '' // markdown 无播放地址
}
